import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { DpTableComponent } from '../../../common-component/dp-table/dp-table.component';
import { SerialNoCellComponent } from '../../../table-cell/serial-no-cell.component';
import {
  GlobalRespo,
  GlobalResponseData,
} from '../../../services/raintree/interfaces/global-respo';
import { MasterSearchTransmissionService } from '../../../services/raintree/Transmission/master-search.service';
import { SerialNoUpdateCellComponent } from '../../../table-cell/serial-no-update-cell.component';
import { ToastrService } from 'ngx-toastr';
import { DpLoaderComponent } from "../../../common-component/dp-loader/dp-loader.component";
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

@Component({
  selector: 'global-search-tab',
  standalone: true,
  templateUrl: './global-search-tab.component.html',
  styleUrl: './global-search-tab.component.scss',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatDialogModule,
    DpTableComponent,
    DpLoaderComponent,
    InfiniteScrollModule,
],
})
export class GlobalSearchTabComponent implements OnInit {
  responseData: any = [];
  @Input() data: any;
  name = new FormControl('', [
    Validators.required,
    Validators.pattern('[-_a-zA-Z0-9 ]*'),
  ]);

  @Output() serialNo: EventEmitter<any> = new EventEmitter<any>();
  isLoader: boolean=false;
  pageNo:number=1;
  pageSize:number=200;
  isLoading: boolean=false;
  noDataFound: boolean=false;
  numberOfLoaders=20;
  constructor(private _masterSearchService: MasterSearchTransmissionService,
    public toaster: ToastrService,
  ) {}

  ngOnInit(): void {
    this.name.patchValue(this.data.name);
  }

  public displayColumnData: any = [
    {
      id: 'slNo',
      name: 'Sl.no',
    },
    {
      id: 'memberStatus',
      name: 'Mem Status',
    },
    {
      id: 'district',
      name: 'District',
    },
    {
      id: 'fullName',
      name: 'Name',
    },
    {
      id: 'guardianFullName',
      name: 'Guardian',
    },
    {
      id: 'initiationDate',
      name: 'Initiation Date',
    },
    {
      id: 'ritwik',
      name: 'Ritwik',
    },
    {
      id: 'pincode',
      name: 'Pin',
    },
    {
      id: 'address',
      name: 'Adress',
    },
  ];

  columnConfs = {
    memberStatus: { cssClass: 'memberStatuswidth' },
    pincode: { cssClass: 'pincodewidth' },
  };

  cellComponentMap = {
    slNo: SerialNoUpdateCellComponent,
  };

  onMasterSearch(isStart?:boolean) {
    if(isStart){
      this.isLoader=true;
      this.pageNo=1;
      this.responseData=[];
    }

    if (this.name.invalid) {
      // return;
      this.name.setValue('');
      this.noDataFound = true;
      this.isLoader = false;
      this.toaster.error('Enter Valid Search Data');
    }else{
      let inpData: string | null = this.name?.value;

      this._masterSearchService
  .fetchGlobalSearchRecords(inpData!, this.pageNo, this.pageSize)
  .subscribe({
    next: (response: GlobalResponseData) => {
      this.isLoader = false;
      this.noDataFound = false;

      if (response.data.memberList && response.data.memberList.length === 0) {
        if (isStart) {
          this.noDataFound = true;
        }
      } else if (response.data.memberList && response.data.memberList.length > 0) {
        this.responseData = [
          ...this.responseData,
          ...response.data.memberList.map((user: GlobalRespo) => {
            return {
              slNo: user.mk,
              fullName: user.fn + ' ' + user.ln,
              district: user.dn,
              memberStatus: 'FW Pending',
              guardianFullName: user.gfn + ' ' + user.gln,
              initiationDate: user.md,
              ritwik: user.rn,
              pincode: user.pn,
              address: user.add,
            };
          }),
        ];
      } else {
        if (isStart) {
          this.noDataFound = true;
        }
      }
    },
    error: (error) => {
      console.log(error);
    },
  });

    } 
  }

  onScroll(){
    console.log('scroll event occured')
    this.pageNo+=1;
    this.onMasterSearch(false);
  }

  onClickClear(){
    this.name.setValue('');
    this.responseData=[];
  }

  onCellClick(event: any) {
    this.serialNo.emit(event);
  }
}
